export default {"src":"/_next/static/media/policies.9d2a996b.svg","height":50,"width":42,"blurWidth":0,"blurHeight":0};